<app-layout>
    <mat-toolbar class="page-header" role="heading">
        <h1>{{ 'AbsenceReport' | translate: {Default: "Absence Report"} }}</h1>
    </mat-toolbar>

    <div class="content">
        <app-absence-details-data-grid></app-absence-details-data-grid>
    </div>
</app-layout>
